import React from 'react';
import MaskedInput from 'react-text-mask';

interface CustomDateInputProps {
    value: any;
    id: string;
    disabled?: boolean;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const DatePickerInputMask: React.FC<CustomDateInputProps> = ({ value, id, disabled, placeholder = 'mm/dd/yyyy', onChange, onBlur }) => {
    return (
        <div style={{ position: 'relative' }}>
            <MaskedInput
                mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                placeholder={placeholder}
                value={value}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                    e.target.value = value;
                    onBlur?.(e);
                }}
                id={id}
                data-testid={id}
                disabled={disabled}
                autoComplete="off"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e)}
            />
        </div>
    );
};

export default DatePickerInputMask;
